import { NameSpacing } from '../../../NonReact/utils/NameSpacing'

const GENERAL: string = 'general'

export enum GeneralFieldNames {
    DEVICE_GUID = 'deviceGuid',
    DEVICE_NUMBER = 'deviceNumber',
    DESCRIPTION = 'description',
    DEVICE_TYPE = 'deviceType',
    PARTITION_DISPLAY = 'partitionDisplay',
    PART_ID_IN_TELSYS = 'partIDInTelSys',
    ID_ON_TELSYS = 'idOnTelSys',
    ID_ON_TELSYS_OWNER = 'idOnTelSysOwner',
    ID_ON_TELSYS_DIVISION = 'idOnTelSysDivision',
    DEVICE_NUMBER_INTERNAL = 'deviceNumberInternal',
    TELSYS_USER_ID = 'telSysUserID',
    TELSYS_PASSWORD = 'telSysPassword',
    PRIMARY_EMAIL = 'primaryEmail',
    OVERRIDE_MONITORING = 'overrideMonitoring',
    DISABLE_RT_MONITORING = 'disableRTMonitoring',
    UPDATE_EXISTING_ITEMS = 'updateExistingItems'
}

const GeneralNameSpacing = (fieldName: string): string => NameSpacing(GENERAL, fieldName)

export const DEVICE_GUID_FIELD: string = GeneralNameSpacing(GeneralFieldNames.DEVICE_GUID)
export const DEVICE_NUMBER_FIELD: string = GeneralNameSpacing(GeneralFieldNames.DEVICE_NUMBER)
export const DEVICE_DESCRIPTION_FIELD: string = GeneralNameSpacing(GeneralFieldNames.DESCRIPTION)
export const DEVICE_TYPE_FIELD: string = GeneralNameSpacing(GeneralFieldNames.DEVICE_TYPE)
export const DEVICE_PARTITION_DISPLAY_FIELD: string = GeneralNameSpacing(GeneralFieldNames.PARTITION_DISPLAY)
export const DEVICE_PART_ID_FIELD: string = GeneralNameSpacing(GeneralFieldNames.PART_ID_IN_TELSYS)
export const DEVICE_ID_ON_TELSYS_FIELD: string = GeneralNameSpacing(GeneralFieldNames.ID_ON_TELSYS)
export const DEVICE_ID_ON_TELSYS_OWNER_FIELD: string = GeneralNameSpacing(GeneralFieldNames.ID_ON_TELSYS_OWNER)
export const DEVICE_ID_ON_TELSYS_DIVISION_FIELD: string = GeneralNameSpacing(GeneralFieldNames.ID_ON_TELSYS_DIVISION)
export const DEVICE_NUMBER_INTERNAL_FIELD: string = GeneralNameSpacing(GeneralFieldNames.DEVICE_NUMBER_INTERNAL)
export const DEVICE_TELSYS_USER_ID_FIELD: string = GeneralNameSpacing(GeneralFieldNames.TELSYS_USER_ID)
export const DEVICE_TELSYS_PASSWORD_FIELD: string = GeneralNameSpacing(GeneralFieldNames.TELSYS_PASSWORD)
export const DEVICE_PRIMARY_EMAIL_FIELD: string = GeneralNameSpacing(GeneralFieldNames.PRIMARY_EMAIL)
export const DEVICE_OVERRIDE_MONITORING_FIELD: string = GeneralNameSpacing(GeneralFieldNames.OVERRIDE_MONITORING)
export const DEVICE_DISABLE_RT_MONITORING_FIELD: string = GeneralNameSpacing(GeneralFieldNames.DISABLE_RT_MONITORING)
export const DEVICE_UPDATE_EXISTING_ITEMS_FIELD: string = GeneralNameSpacing(GeneralFieldNames.UPDATE_EXISTING_ITEMS)
